import _pt from "prop-types";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';

// TODO: Should this extend SVG props?
function SvgIcon(_ref) {
  var ariaHidden = _ref.ariaHidden,
      className = _ref.className,
      children = _ref.children,
      description = _ref.description,
      id = _ref.id,
      inversed = _ref.inversed,
      title = _ref.title,
      viewBox = _ref.viewBox;
  var svgClasses = classNames('ds-c-icon', {
    'ds-c-icon--inverse': inversed
  }, className);

  var _useState = useState(id || uniqueId('icon-')),
      _useState2 = _slicedToArray(_useState, 1),
      iconId = _useState2[0];

  var titleId = "".concat(iconId, "__title");
  var descriptionId = "".concat(iconId, "__desc");
  var ariaLabelledBy = description ? "".concat(titleId, " ").concat(descriptionId) : titleId;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    className: svgClasses,
    focusable: false,
    id: iconId,
    role: "img",
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), description && /*#__PURE__*/React.createElement("desc", {
    id: descriptionId
  }, description), children);
}

SvgIcon.propTypes = {
  /**
     * Describes the value of the `aria-hidden` attribute on the SVG. Defaulted to true with the assumption that most icons are decorative.
     * If the icon does not have any associated label text, set this to `false` and ensure a `title` is provided for improved accessibility.
     */
  ariaHidden: _pt.bool,

  /**
     * Additional CSS classes to be added to the svg element
     */
  className: _pt.string,

  /**
     * The elements that make up the SVG
     */
  children: _pt.node.isRequired,

  /**
     * Long-text description of any SVG. Use for complex icons, otherwise `title` prop will suffice.
     */
  description: _pt.string,

  /**
     * A custom `id` attribute for the SVG
     */
  id: _pt.string,

  /**
     * If `true` sets inverse fill color.
     */
  inversed: _pt.bool,

  /**
     * The descriptive name for the SVG icon
     */
  title: _pt.string.isRequired,

  /**
     * A string describing the viewbox of the SVG.
     *
     * It is recommended that the icon is centered and fill up the default viewport size.
     * See [this blog post](https://webdesign.tutsplus.com/tutorials/svg-viewport-and-viewbox-for-beginners--cms-30844) for further explanation on viewBox and how to use it.
     */
  viewBox: _pt.string
};
SvgIcon.defaultProps = {
  ariaHidden: true,
  inversed: false
};
export default SvgIcon;